import type { PageContext } from 'vike/types'
const routeRegex = /\/(buy|rent)((\/[^/]+)*)/
export function route(pageContext: PageContext) {
  const match = pageContext.urlPathname.match(routeRegex)
  if (!match) return false
  const [, mode, path] = match
  return {
    routeParams: { mode, path: mode + path, place: path, subpath: '' }
  }
}
